export const HISTORY_DATA_MANAGEMENT_ACTIONS = {
  GET_HISTORY_DATA: 'GET_HISTORY_DATA',
  GET_HISTORY_DATA_SUCCESS: 'GET_HISTORY_DATA_SUCCESS',
  GET_HISTORY_DATA_ERROR: 'GET_HISTORY_DATA_ERROR',
  GET_HISTORY_DATA_CLEAN_STATE: 'GET_HISTORY_DATA_CLEAN_STATE',
};
// =========================================================================
export const getHistoryData = (params) => ({
  type: HISTORY_DATA_MANAGEMENT_ACTIONS.GET_HISTORY_DATA,
  payload: params,
});
export const getHistoryDataSuccess = (data) => ({
  type: HISTORY_DATA_MANAGEMENT_ACTIONS.GET_HISTORY_DATA_SUCCESS,
  payload: data,
});
export const getHistoryDataError = ({ message }) => ({
  type: HISTORY_DATA_MANAGEMENT_ACTIONS.GET_HISTORY_DATA_ERROR,
  payload: message,
});
export const getHistoryDataCleanState = () => ({
  type: HISTORY_DATA_MANAGEMENT_ACTIONS.GET_HISTORY_DATA_CLEAN_STATE,
});
// =========================================================================
